<script setup>
  import { DialogDescription, DialogPanel, DialogTitle } from '@headlessui/vue'
  import { Form } from 'vee-validate'
  import * as yup from 'yup'
  import { notify } from 'notiwind'

  const props = defineProps({
    close: { type: Function, required: true },
    optional: { type: Boolean, default: false },
    onSubmit: { type: Function, required: true }
  })

  const schema = yup.object({
    experience: yup.string().required('Ce champ est requis'),
    sectors: yup.array().min(1, 'Ce champ est requis'),
    skills: yup.array()
  })

  const client = useStrapiClient()
  const { find } = useStrapi4()
  const { user } = useUser()

  const sectors = reactive({
    ...useLazyAsyncData('sectors-skills-modal', async () => {
      const res = await find('sectors', {
        fields: ['id', 'name'],
        sort: { name: 'asc' },
        pagination: { limit: 100 },
        populate: {
          skills: {
            fields: ['id', 'name']
          }
        }
      })
      return res.data
    })
  })

  const onSubmit = async (values, actions) => {
    try {
      values = schema.cast(values, { stripUnknown: true })
      await client(`/candidates/${user.value.candidate.id}`, {
        method: 'PUT',
        body: {
          data: {
            experience: values.experience,
            sectors: values.sectors,
            skills: values.skills
          }
        }
      })
      notify({ group: 'main', type: 'success', title: 'Profil mis à jour' })
    } catch (error) {
      console.error(error)
      notify({
        group: 'main',
        type: 'danger',
        title: 'Une erreur s’est produite',
        text: 'Votre profil n’a pas pu être mis à jour'
      })
    }

    props.onSubmit()
  }
</script>

<template>
  <DialogPanel class="my-auto w-full max-w-lg rounded-xl bg-white p-4 shadow">
    <DialogTitle class="text-center font-special text-3xl font-bold">Je complète mon profil</DialogTitle>
    <DialogDescription class="mt-4 text-center"> pour augmenter mes chances </DialogDescription>

    <Form class="mt-4" v-slot="{ errors, values, setValues, isSubmitting }" :validationSchema="schema" @submit="onSubmit">
      <div class="-m-2 flex flex-wrap">
        <FormField
          class="basis-full p-2"
          id="experience"
          custom
          :error="errors.experience"
          placeholder="Votre niveau d'expérience"
          name="experience"
          required
          type="select"
          :value="user.candidate.experience"
          :options="[
            { label: 'Débutant', value: 'beginner' },
            { label: 'Intermédiaire', value: 'junior' },
            { label: 'Avancé', value: 'confirmed' },
            { label: 'Expert', value: 'senior' }
          ]"
        />
        <FormDomainsAndSkills
          class="basis-full"
          v-if="sectors.data"
          :sectors="sectors.data"
          :errors="errors"
          :values="values"
          :setValues="setValues"
        />
      </div>
      <div class="mt-4 grid grid-rows-2 text-center sm:grid-cols-3 sm:grid-rows-1">
        <div class="space-x-1 sm:col-start-2">
          <Button color="secondary" outline type="reset" @click="close">Annuler</Button>
          <Button :disabled="isSubmitting" type="submit">Postuler</Button>
        </div>
        <span
          class="cursor-pointer p-2 text-viking-400 underline duration-300 hover:text-viking-500 sm:ml-auto"
          v-if="props.optional"
          @click="() => props.onSubmit()"
          >Je le ferai plus tard</span
        >
      </div>
    </Form>
  </DialogPanel>
</template>
